import React from 'react';
import { useNavigate } from 'react-router-dom';
import { theme } from '../styles/theme';
import Button from './ui/Button';
import { FaExclamationTriangle } from 'react-icons/fa';

interface LimitReachedBannerProps {
  linkCount: number;
  linkLimit: number;
}

const LimitReachedBanner: React.FC<LimitReachedBannerProps> = ({ linkCount, linkLimit }) => {
  const navigate = useNavigate();

  // Only show if at or over limit
  if (linkCount < linkLimit) {
    return null;
  }

  const handleUpgrade = () => {
    navigate('/pricing');
  };

  return (
    <div style={{
      backgroundColor: '#FEF3C7',
      borderBottom: `3px solid #F59E0B`,
      padding: '16px 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '16px',
      flexWrap: 'wrap'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        flex: 1
      }}>
        <div style={{ color: '#D97706' }}>
          {FaExclamationTriangle({ size: 20 })}
        </div>
        <div>
          <p style={{
            margin: 0,
            fontSize: theme.typography.sizes.base,
            fontWeight: theme.typography.weights.semibold,
            color: '#92400E'
          }}>
            You've reached your free plan limit
          </p>
          <p style={{
            margin: '4px 0 0 0',
            fontSize: theme.typography.sizes.sm,
            color: '#92400E'
          }}>
            You're at {linkCount} of {linkLimit} trackable links. Upgrade to Pro for unlimited links!
          </p>
        </div>
      </div>
      <Button
        variant="primary"
        size="md"
        onClick={handleUpgrade}
        style={{
          backgroundColor: '#D97706',
          whiteSpace: 'nowrap'
        }}
      >
        Upgrade to Pro
      </Button>
    </div>
  );
};

export default LimitReachedBanner;
